import { PBPListResponse } from '@percent/admin-dashboard/services/pbpResponses'
import { AccountServiceCapabilities, GetAccountsProps } from './accounts.types'
import { Account } from '@percent/domain/iam'
import { throttleAsync } from '@percent/utility'

export const accountService = ({ percentClient }: AccountServiceCapabilities) => ({
  getAccounts: throttleAsync(
    (params: GetAccountsProps) => percentClient.get<PBPListResponse<Account>>('/v1/admin/iam/accounts', { params }),
    1000,
    { leading: true, trailing: true }
  ),
  reset2FA: ({ accountId }: { accountId: string }) =>
    percentClient.post(`/v1/admin/iam/accounts/${accountId}/2fa/temp-backup-code`),
  inviteUser: ({ email, fullName, employeeType }: { email: string; fullName: string; employeeType: string }) =>
    percentClient.post('/v1/admin/iam/accounts/invite', {
      email,
      fullName,
      employeeType
    }),
  updateAdminStatus: ({ accountId, admin }: { accountId: string; admin: boolean }) =>
    percentClient.post(`/v1/admin/iam/accounts/${accountId}/admin`, { admin }),
  removeAccount: ({ id }: { id: string }) => percentClient.delete(`/v1/admin/iam/accounts/${id}`),
  redactAccount: ({ id }: { id: string }) => percentClient.post(`/v1/admin/iam/accounts/${id}/redact`),
  reactivateAccount: ({ id }: { id: string }) => percentClient.post(`/v1/admin/iam/accounts/${id}/reactivate`)
})
